import React from 'react'

interface PaperProps {
    children: React.ReactNode
    className?: string
    id?: string
}

const Paper: React.FC<PaperProps> = ({ children, className, id }) => {
    return (
        <div id={id} className={`bg-white rounded-sm p-4 ${className}`}>
            {children}
        </div>
    )
}

export default Paper
